import { Box, BoxProps } from '@jfs/ui-new'
import { useFocusEffect, useRoute } from '@react-navigation/native'
import React, { useCallback, useRef, useState } from 'react'
import { useWindowDimensions } from 'react-native'
import { Container } from '../../../components/Container'
import { NewTable } from '../../../components/NewTable'
import { useLazyApiData, useStores } from '../../../data/store'
import { AuditForMidModal } from '../AuditForMidModal'
import { FraudAndRiskHeader } from '../FraudAndRiskHeader'

export const GenericAuditScreen = () => {
  const TYPE = (useRoute()?.params as any)?.type
  const { auditListAsync, groupedAuditList, resetPagination } = useStores((store) => ({
    auditListAsync: store.riskConfig.auditListAsync,
    groupedAuditList: store.riskConfig.getGroupedAuditList(),
    resetPagination: store?.resetPagination,
  }))
  const [mid, setSelectedMid] = useState('')
  const [lazyAuditList, auditListHandler] = useLazyApiData(auditListAsync)
  const { width }: any = useWindowDimensions()

  const [show, setShow] = useState(false)
  const [clickedTransaction, setClickedTransaction] = useState({})
  const [tableWidth, setTableWidth] = React.useState(width)

  const abortControllerRef = useRef<AbortController>()
  const fetchGroupByRiskTnx = useCallback(() => {
    abortControllerRef?.current?.abort()
    abortControllerRef.current = new AbortController()
    lazyAuditList(TYPE, mid, abortControllerRef?.current)
  }, [TYPE, mid, lazyAuditList])
  useFocusEffect(fetchGroupByRiskTnx)

  const onRowClick = useCallback((data: any) => {
    setClickedTransaction(data)
    setShow(true)
  }, [])

  const onSearchByMidClick = (mid: any) => {
    console.log('setSelectedMid', mid)
    setSelectedMid(mid)
    resetPagination()
    fetchGroupByRiskTnx()
  }

  const onMidChange = useCallback((updatedMid: any) => {
    setSelectedMid(updatedMid)
  }, [])
  const onDismiss = useCallback(() => setShow(false), [])
  return (
    <Box {...styles.container}>
      <FraudAndRiskHeader
        type={TYPE}
        fetchDataOnChange={fetchGroupByRiskTnx}
        showSearchBy={false}
        showSearchByMid={true}
        onSearchByMidClick={onSearchByMidClick}
        initialSearchMid={mid}
        onMidChange={onMidChange}
      />
      <Container
        isLoading={auditListHandler.state === 'pending'}
        errorMessage={auditListHandler?.data?.message}
        paddingTop={16}
        flex={1}
        onLayout={({ nativeEvent: { layout } }) => {
          setTableWidth(layout?.width)
        }}
        nativeID="vertical-scroll"
        onRetry={fetchGroupByRiskTnx}>
        <NewTable
          data={groupedAuditList}
          rowHeight={48}
          headerHeight={64}
          tableWidth={width > 1200 ? tableWidth : width}
          headerRowKeys={headerTitles}
          customWidthFunc={getCustomColumnWidth}
          onRowClick={onRowClick}
        />
      </Container>
      {show && (
        <AuditForMidModal show={show} onDismiss={onDismiss} clickedMerchantDetail={clickedTransaction} type={TYPE} />
      )}
    </Box>
  )
}

const headerTitles = {
  entityId: 'MID',
  //entityName: 'Businees Name',
  settlementNetAmount: 'Total Amount',
  totalCount: 'Total Count',
}

export const getCustomColumnWidth = (columnKey: string) => {
  const columnsKeyWidth: any = {
    entityId: 80,
    entityName: 80,
    settlementNetAmount: 80,
    totalCount: 80,
  }
  return columnsKeyWidth[columnKey] ?? 150
}

const styles = {
  container: {
    height: '100%',
    backgroundColor: 'WHITE',
    borderWidth: 1,
    ph: 16,
    pv: 24,
    borderColor: 'GREY_SEPARATOR',
  } as BoxProps,
}
